<div class="main">
    <div class="text-center">
      <img src="assets/image/success-icon.svg" />
    </div>
    <div class="mt-3 text-center">
      <h2>E-mail enviado com sucesso!</h2>
      <p class="mt-3 mb-5">
        Acesse o link enviado no e-mail para a criação de uma nova senha para acessar a plataforma. Caso ainda não tenha recebido, aguardar um instante e olhar na lista de lixo eletrônico do seu leitor de e-mail.
      </p>
    </div>
    <div>
      <button class="btn btn-block mt-3" type="button" (click)="goToLogin()">
        Fazer login
      </button>
    </div>
  </div>
   